module.exports = __webpack_public_path__ + "static/media/10.32aaf976.jpg";